import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import ClearOutlinedIcon from 'components/material-symbol/icons/Clear'
import { useStyles } from '../styles'

const AccessCode = () => {
  const { register, errors, setValue, watch } = useFormContext()
  const classes = useStyles()
  const accessCode = watch('accessCode')
  const clearAccessCode = () => setValue('accessCode', '')

  return (
    <Box className={classes.fieldGroup} width="100%">
      <TextField
        name="accessCode"
        label="Access code"
        type="text"
        inputRef={register}
        placeholder="Optional"
        error={!!errors.accessCode}
        helperText={
          errors?.accessCode?.message ||
          'Add a code to keep registration private.'
        }
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
        InputProps={{
          endAdornment: accessCode ? (
            <InputAdornment position="end">
              <IconButton
                onClick={clearAccessCode}
                aria-label="Clear access code"
              >
                <ClearOutlinedIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </Box>
  )
}

export default AccessCode
